import { Col, Row, Switch, Tooltip } from "antd";
import React from "react";
import { IconArrowDown, IconArrowTop, IconXmark } from "../../../assets/icon";

const EnterContent = ({
  handleSortUp,
  listQS,
  handleSortDown,
  index,
  handleDelete,
  setListQS,
  // valueEdit,
}) => {
  return (
    <Row>
      <Col span={3} style={{ display: "flex", alignItems: "center" }}></Col>
      <Col span={3}>
        <div className="tdQS">
          <span className="QSnumber">Câu {index}</span>
        </div>
      </Col>
      <Col span={6}>
        <div className="tdQS">
          <textarea
            rows={4}
            className="question"
            placeholder="Nhập câu hỏi"
            value={listQS.find((item) => item.index === index).nameQuestion}
            onChange={(e) => {
              setListQS(() => {
                const result = listQS.map((item) => {
                  if (item.index === index) {
                    return {
                      ...item,
                      nameQuestion: e.target.value,
                    };
                  }
                  return item;
                });
                return result;
              });
            }}
          ></textarea>
        </div>
      </Col>
      <Col span={7}>
        <div className="tdQS tdEmotion">
          <p className="titleAnswer">Nhập nội dung</p>
          <textarea
            rows={3}
            className="question"
            placeholder="Nhập trả lời"
          ></textarea>
        </div>
      </Col>
      <Col span={2}>
        <div className="tdQS btnFuntion">
          <Switch
            checked={listQS.find((item) => item.index === index).required === 1}
            onChange={(value) => {
              setListQS(() => {
                const result = listQS.map((item) => {
                  if (item.index === index) {
                    return {
                      ...item,
                      required: value ? 1 : 0,
                    };
                  }
                  return item;
                });
                return result;
              });
            }}
          />
        </div>
      </Col>
      <Col span={3}>
        <div className="tdQS btnFuntion">
          <span className="pointer ">
            {listQS.length <= 1 ? null : index === 1 ? (
              <IconArrowDown onClick={() => handleSortDown(index)} />
            ) : index === listQS.length ? (
              <IconArrowTop onClick={() => handleSortUp(index)} />
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <IconArrowTop
                  style={{ marginBottom: 5 }}
                  onClick={() => handleSortUp(index)}
                />
                <IconArrowDown onClick={() => handleSortDown(index)} />
              </div>
            )}
          </span>

          <span
            className="pointer iconDelete"
            onClick={() => {
              handleDelete(listQS.find((item) => item.index === index));
            }}
          >
            <Tooltip title="Xóa">
              <IconXmark />
            </Tooltip>
          </span>
        </div>
      </Col>
    </Row>
  );
};

export default EnterContent;
